import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { space } from 'config/theme'
import { pxToRem } from 'utils/helpers'
import { COLORS } from 'config/constants'
import { Box } from 'components/atoms/Layout'
import { triangle, math } from 'polished'

const TRIANGLE_HEIGHT = space.s

const Content = styled.div`
  display: flex;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
  position: absolute;
  min-width: ${pxToRem(200)};
  max-width: ${pxToRem(250)};
  bottom: 0;
  transform: translateY(calc(100% + ${math(`${TRIANGLE_HEIGHT} * 1.5`)}));
  background-color: ${COLORS.WHITE};
  border-radius: ${pxToRem(6)};
  box-shadow: rgba(32, 32, 32, 0.1) 0px 13px 38px 0px;
  transition: opacity 0.5s;
  ::before {
    content: '';
    position: absolute;
    top: 0;
    transform: translateY(-100%);
    ${triangle({
      pointingDirection: 'top',
      width: math(`${TRIANGLE_HEIGHT} * 1.5`),
      height: TRIANGLE_HEIGHT,
      foregroundColor: COLORS.WHITE,
    })}
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &:hover ${Content} {
    visibility: visible;
    opacity: 1;
  }
`

const Tooltip = ({ children, contentComp }) => (
  <Wrapper>
    {children}
    <Content>
      <Box p="m">{contentComp}</Box>
    </Content>
  </Wrapper>
)

Tooltip.propTypes = {
  children: PropTypes.node,
  contentComp: PropTypes.node,
}

export default Tooltip
